const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
  t /= d/2
  if (t < 1) {
    return c / 2 * t * t + b
  }
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

const useAnimateScroll = () => {
  const scrollTo = (element: HTMLElement, to: number, duration: number) => {
    const start = element.scrollLeft
    const change = to - start
    let currentTime = 0
    const increment = 5

    const animateScroll = () => {
      currentTime += increment
      const val = easeInOutQuad(currentTime, start, change, duration)
      element.scrollLeft = val
      if(currentTime < duration) {
        setTimeout(animateScroll, increment)
      }
    }

    animateScroll()
  }

  return scrollTo
}

export default useAnimateScroll
